import { IColumnDef } from '../../../Types/ColumnDefType';
import { ICollectionDataType } from '../../../Features/Delsystem/_Common/Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { IClientBusinessModel } from '../../../Types/ClientModelTypes';
import { AvenyCollectionMap } from '../../../Model/ModelContext/ModelContext';
import {
  safeGetAssociationInfo,
  safeGetAttributeModel,
} from '../../../Model/avenyModelUtils';

export const transformToContextData = (
  rows: ICollectionDataType[],
  columns: readonly IColumnDef[],
  collection: IClientBusinessModel,
  avenyCollectionMap: AvenyCollectionMap,
  skipColumnFiltering = false
): string => {
  const jsonlLines: string[] = [];

  rows.forEach(row => {
    const transformedRow = transformRow(
      '',
      row,
      columns,
      collection,
      avenyCollectionMap,
      skipColumnFiltering
    );

    jsonlLines.push(JSON.stringify(transformedRow));
  });

  return jsonlLines.join('\n');
};

const transformRow = (
  path: string,
  row: ICollectionDataType,
  columns: readonly IColumnDef[],
  collection: IClientBusinessModel,
  avenyCollectionMap: AvenyCollectionMap,
  skipColumnFiltering: boolean
): object => {
  const transformedRow: Record<string, unknown> = {};

  if (row && typeof row === 'object') {
    Object.entries(row).forEach(([key, value]) => {
      if (
        key === 'id' ||
        key === '_version' ||
        key === '_typ' ||
        key === '__typename'
      )
        return;

      if (key == '_Associations' && value && typeof value === 'object') {
        (Object.entries(value as Record<string, unknown>) as [string, ICollectionDataType][]).forEach(
          ([associationKey, associationValue]) => {
            if (
              associationKey === 'id' ||
              associationKey === '_version' ||
              associationKey === '_typ' ||
              associationKey === '__typename'
            )
              return;

            if (!transformedRow['_Associations']) {
              transformedRow['_Associations'] = {};
            }
            (transformedRow['_Associations'] as Record<string, unknown>)[
              getAssociationDisplayLabel(
                path ? path + '.' + associationKey : associationKey,
                collection,
                avenyCollectionMap
              )
            ] = transformRow(
              path ? path + '.' + associationKey : associationKey,
              associationValue as ICollectionDataType,
              columns,
              collection,
              avenyCollectionMap,
              skipColumnFiltering
            );
          }
        );
      } else {
        if (
          skipColumnFiltering === false &&
          !columns.some(
            col => col.attributeDef === (path ? path + '.' + key : key)
          )
        ) {
          return;
        }

        transformedRow[
          getAttributeDisplayLabel(
            path ? path + '.' + key : key,
            columns,
            collection,
            avenyCollectionMap
          )
        ] = value;
      }
    });
  }

  return transformedRow;
};

const getAttributeDisplayLabel = (
  attributePath: string,
  columns: readonly IColumnDef[],
  collection: IClientBusinessModel,
  avenyCollectionMap: AvenyCollectionMap
): string => {
  const column = columns.find(col => col.attributeDef === attributePath);
  return (
    column?.caption ||
    safeGetAttributeModel(collection, attributePath, avenyCollectionMap)
      ?.DisplayLabel ||
    attributePath.split('.').slice(-1)[0]
  );
};

const getAssociationDisplayLabel = (
  associationPath: string,
  collection: IClientBusinessModel,
  avenyCollectionMap: AvenyCollectionMap
): string => {
  return (
    safeGetAssociationInfo(
      collection.CollectionName,
      associationPath,
      avenyCollectionMap
    )?.association.DisplayLabel || associationPath.split('.').slice(-1)[0]
  );
};
